export default __webpack_public_path__ + "static/media/map.89f9ccdd.png";